__turbopack_context__.v({
  "dialog-container": "InfoModal-module-scss-module__8zRNEG__dialog-container",
  "dialog-wrapper": "InfoModal-module-scss-module__8zRNEG__dialog-wrapper",
  "dismiss-button": "InfoModal-module-scss-module__8zRNEG__dismiss-button",
  "headline": "InfoModal-module-scss-module__8zRNEG__headline",
  "hero": "InfoModal-module-scss-module__8zRNEG__hero",
  "modal-body": "InfoModal-module-scss-module__8zRNEG__modal-body",
  "underlay": "InfoModal-module-scss-module__8zRNEG__underlay",
});
